import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LangAlg = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M35.027 0H9.074C4.083 0 .09 4.093.09 9.084v15.571c0 4.991 3.993 9.084 8.984 9.084h2.994c1.597 0 2.895 1.297 2.895 2.995v5.19c0 1.797 2.096 2.695 3.394 1.597l10.181-8.984c.998-.998 3.195-.698 4.392-.698 5.191 0 9.583-3.694 10.681-8.585.2-.798.3-1.597.3-2.495V9.084C44.01 3.993 40.017 0 35.026 0ZM33.03 31.643c-1.896 0-4.292-.2-5.79 1.297L17.16 41.824v-5.09c0-2.796-2.296-5.091-4.991-5.091H9.173c-3.793 0-6.887-3.095-6.887-6.988V9.084c0-3.794 3.094-6.988 6.887-6.988h25.854c3.793 0 6.887 3.095 6.887 6.988v13.575c0 .599-.1 1.298-.2 1.896-.898 3.993-4.392 7.088-8.684 7.088Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M32.531 23.857c.4.4.4 1.098 0 1.497-.4.4-1.098.4-1.497 0l-2.695-2.795-2.695 2.795c-.4.4-1.098.4-1.498 0-.399-.4-.399-1.098 0-1.497l2.795-2.895-2.894-2.895c-.4-.399-.4-1.098 0-1.497.399-.4 1.098-.4 1.497 0l2.695 2.795 2.695-2.795c.4-.4 1.098-.4 1.497 0 .4.4.4 1.098 0 1.497l-2.695 2.895 2.795 2.895Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M19.654 8.485c.2-.4.5-.6.999-.6H33.23c.599 0 .998.5.998 1.099s-.5 1.098-.998 1.098H21.35l-6.688 16.17c-.2.4-.598.7-.998.6-.399 0-.798-.3-.898-.8L9.972 16.27c-.2-.598.2-1.098.699-1.297.599-.2 1.098.2 1.297.699l1.997 6.887 5.69-14.074Z"
  })));
});
LangAlg.displayName = 'LangAlg';
LangAlg.defaultProps = {
  'aria-label': 'LangAlg'
};
export default LangAlg;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/LangAlg.js
// module id = 3027
// module chunks = 11